import React, { useState, useEffect } from 'react';
import {
    Checkbox,
    FormControlLabel,
    Button,
    Alert,
    Grid,
} from '@mui/material';
import LoadingSpinner from '../components/LoadingSpinner';
import SnackbarMessage from '../components/SnackBAr/SnackbarNotification';
import { BASE_URL, getAxiosConfig,  } from '../components/interface/Config';
import { apiHandler } from '../services/authService';


const Communication: React.FC = () => {
    const [isEmail, setIsEmail] = useState(false);
    const [isSms, setIsSms] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState(false);
    const [fetchLoading, setFetchLoading] = useState(false); 
    
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState<'success' | 'info' | 'warning' | 'error'>('success');

    const handleSnackbarClose = () => {
        setSnackbarOpen(false);
    };

    const handleCancel = () => {
        setIsEmail(false);
        setIsSms(false);
        setError(null);
    };

    const fetchUserData = async () => {
        setFetchLoading(true);
    
        try {
            const url        = `${BASE_URL}/users/info`;
            const response   = await apiHandler('', 'GET',{}, url);

            if (!response) {
                throw new Error("No response received from the server");
            }

            const data = response.data;

            // const response = await fetch(`${BASE_URL}/users/info`, {
            //     method: 'GET',
            //     headers: getAxiosConfig().headers, // Correct header setup
            // });
    
            // if (!response.ok) {
            //     const errorData = await response.json();
            //     throw new Error(errorData.message || 'Failed to fetch user data.');
            // }
    
            // const data = await response.json();
            setIsEmail(data.data.communication_channel.email);
            setIsSms(data.data.communication_channel.sms);
        } catch (error: unknown) {
            setError(error instanceof Error ? error.message : 'Error occurred while fetching user data.');
        } finally {
            setFetchLoading(false);
        }
    };
    

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);

        const payload = {
            communication_channel: {
                email: isEmail,
                sms: isSms,
            },
        };

        try {
            const url        = `${BASE_URL}/users/communication`;
            const response   = await apiHandler('', 'PATCH',payload, url);

            if (!response) {
                throw new Error("No response received from the server");
            }

            // const response = await fetch(`${BASE_URL}/users/communication`, {
            //     method: 'PATCH',
            //     headers: {
            //         ...getAxiosConfig().headers,
            //         'Content-Type': 'application/json',
            //     },
            //     body: JSON.stringify(payload),
            // });

            // if (!response.ok) {
            //     const errorData = await response.json();
            //     throw new Error(errorData.message || 'Failed to update communication preferences.');
            // }

            setSnackbarMessage('Communication preferences updated successfully.');
            setSnackbarSeverity('success');
            setSnackbarOpen(true);
            // Snack bar will close after 1 second
            await new Promise(resolve => setTimeout(resolve, 2000));
            await fetchUserData();
        } catch (error: unknown) {
            const errorMessage = error instanceof Error ? error.message : 'An error occurred while updating preferences.';
            setError(errorMessage);
            setSnackbarMessage(errorMessage);
            setSnackbarSeverity('error');
            setSnackbarOpen(true);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchUserData(); // Initial fetch on mount
    }, []); // Re-fetch if token changes

    return (
        <div>
            {error && <Alert severity="error">{error}</Alert>}
            {(loading || fetchLoading) && <LoadingSpinner show={false} onComplete={function (): void {
                throw new Error('Function not implemented.');
            } } />} {/* Display loading spinner */}
            <form onSubmit={handleSubmit}>
                <Grid container spacing={2} direction="row" alignItems="flex-start" justifyContent="flex-start">
                    <Grid item>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={isEmail}
                                    onChange={(e) => setIsEmail(e.target.checked)}
                                    sx={{
                                        '& .MuiSvgIcon-root': {
                                            fontSize: 28,
                                            color: isSms ? '#0870b4' : '#0870b4', 
                                        },
                                    }}
                                />
                            }
                            label="Email"
                        />
                    </Grid>
                    <Grid item>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={isSms}
                                    onChange={(e) => setIsSms(e.target.checked)}
                                    sx={{
                                        '& .MuiSvgIcon-root': {
                                            fontSize: 28,
                                            color: isSms ? '#0870b4' : '#0870b4', 
                                        },
                                    }}
                                />
                            }
                            label="SMS"
                        />
                    </Grid>
                </Grid>
                <div className="flex justify-center space-x-4 mt-6">
                    <Button
                        variant="contained"
                        sx={{
                            backgroundColor: 'white',
                            border: '2px solid #0870b4',
                            color: '#000000',
                            transition: 'background-color 0.3s ease, border-color 0.3s ease, transform 0.3s ease',
                            '&:hover': {
                                color: '#0870b4',
                               
                                borderColor: '#0870b4',
                            },
                        }}
                        onClick={handleCancel}
                    >
                        Cancel
                    </Button>

                    <Button
                        variant="contained"
                        color="primary"
                        className="bg-gradient-to-r from-primary to-primary text-white hover:from-primary hover:to-primary"
                        type="submit"
                    >
                        Save
                    </Button>
                </div>
            </form>

            {/* Snackbar for messages */}
            <SnackbarMessage
                open={snackbarOpen}
                message={snackbarMessage}
                severity={snackbarSeverity}
                onClose={handleSnackbarClose}
            />
        </div>
    );
};

export default Communication;
